<div id="container">
  <div id="inner_container">

    <div class="header notfound_page_header">
      <div class="t_head">404</div>
      <div class="s_head">FILE NOT FOUND</div>
    </div>

    <div *ngIf="lang === 'ja'" class="desc">
      <ul>
        <li>{{ lang | i18nSelect: strings.notFound.description1 }}</li>
        <li>{{ lang | i18nSelect: strings.notFound.description2 }}</li>
        <li>{{ lang | i18nSelect: strings.notFound.description3 }}</li>
      </ul>
    </div>

    <div class="carzy">
      <a href="{{ appUrl }}">
        <div class="carzy_ci"><img src="assets/img/carzy_ci300.png" width="150"
            alt="{{ lang | i18nSelect: strings.nav.carzy }}" /></div>
        <div class="carzy_url">{{ appUrl }}</div>
      </a>
    </div>

    <ng-container *ngIf="carRankingCollection$ | async as carRankingCollection">
      <section>
        <div class="page_box carlist carlayoutlist" id="rankingcarlist">
          <div class="inner_contents_box inner_carlist">
            <div class="page_header fix_center txtalcenter">
              <div class="inner_page_header ffamily">
                <h2 class="t_head">{{ lang | i18nSelect:strings.notFound.rankingTitle }}</h2>
              </div>
            </div>
            <div class="stocklist_contents posrelative fix_center_large">
              <div class="inner_stocklist_contents">
                <ul class="flex_layout flex_wrap">
                  <li *ngFor="let car of carRankingCollection.items; let i = index">
                    <div class="car_box rankinglabel ranking{{ i + 1 }}">
                      <app-car-list-item [car]="car" [lang]="lang" [isRanking]="true"></app-car-list-item>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </ng-container>

  </div>
</div>